// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getFilteredEndUseCodes} from '../../shared/repositories';

export const readFilteredEndUseCodes = (filter1, filter2, filter3) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getFilteredEndUseCodes(filter1, filter2, filter3);

            dispatch({
                data,
                property: 'endUseCodes',
                type: actions.UPDATE_NEW_REGISTRATION_DOMAIN_VALUES
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/filtered-end-use-codes.js